<p-dialog
  [visible]="showSaveMobileBusinessDialog"
  (visibleChange)="onFlag('showSaveMobileBusinessDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [showHeader]="false"
  [baseZIndex]="4000"
  maskStyleClass="savemobile-business-dialog-mask"
  appendTo="body"
  styleClass="savemobile-business-dialog"
  class="dialog">
  <div class="choice-button-block">
    <button (click)="downloadContact()" class="save-button full-width">
      <img
        alt="add-user"
        class="gs-icon"
        src="/assets/images/pitch-card-svg/add-user.svg" />
      <span>SAVE TO CONTACTS</span>
    </button>
    <button
      (click)="this.openSaveBusinessDialog()"
      class="save-button full-width">
      <img
        alt="pocket-outline"
        class="gs-icon"
        src="/assets/images/pitch-card-svg/pocket-outline.svg" />
      <span>SAVE TO POCKETS</span>
    </button>
  </div>
</p-dialog>
@if (!isMobile) {
  <p-dialog
    (onHide)="clearCarouselAllPocketsVariable()"
    [visible]="showSaveBusinessDialog"
    (visibleChange)="onFlag('showSaveBusinessDialog', $event)"
    [blockScroll]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="true"
    [position]="'bottom'"
    [style]="{
      paddingTop: '10px',
      margin: '0',
      width: 'calc(100vw - 80px)',
      maxWidth: '1080px',
      minHeight: '380px',
      position: 'relative'
    }"
    [appendTo]="isSearch ? 'body' : null"
    class="dialog save-dialog save-business-dialog"
    styleClass="save-business-dialog-panel">
    <ng-template pTemplate="header">
      <div class="save-pocket-dialog-heading">
        <h2 class="text-nowrap text-white">Choose a Pocket</h2>
        <div class="absolute flex justify-content-between w-full left-0 px-5">
          <h2 class="text-nowrap">Choose a Pocket</h2>
          <button
            (click)="onFlag('detailsPocketModal', true)"
            class="create-pocket-button"
            type="button">
            <span aria-hidden="true" class="plus-icon">+</span>
            <span>Create new pocket</span>
          </button>
        </div>
      </div>
    </ng-template>
    @if (carouselAllPocketsLoader) {
      <i class="fa fa-spinner fa-pulse fa-5x fa-fw pockets-loader"></i>
    }
    @if (carouselAllPockets().length) {
      <div class="save-business-pockets-carousel">
        <p-carousel
          #pocketsCarousel
          [numScroll]="numScroll"
          [numVisible]="numVisible"
          [responsiveOptions]="responsiveOptions"
          [showNavigators]="
            carouselAllPockets().length > getVisibleSlideNumbers()
          "
          [value]="carouselAllPockets()">
          <ng-template let-pocket pTemplate="item">
            <div class="pocket-slide">
              <app-pitchcard-folder-thumbnail
                [pocketColor]="
                  pocket?.organizationId
                    ? '#24aeb5'
                    : !!pocket?.hexColor && !pocket.default
                      ? '#' + pocket.hexColor
                      : '#' + pocket.color
                "
                (addContent)="saveBusinessToPocket($event, '')"
                [onlyFolder]="true"
                [pitchCardFolder]="pocket"
                [scaleFactor]="0.4"
                class="pocket"></app-pitchcard-folder-thumbnail>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    }
  </p-dialog>
}

<p-dialog
    (onHide)="clearDetailsModalOptions()"
    [visible]="detailsPocketModal"
    (visibleChange)="onFlag('detailsPocketModal', $event)"
    [blockScroll]="true"
    [dismissableMask]="isMobile"
    [draggable]="false"
    [modal]="true"
    [style]="{ paddingTop: '10px', maxWidth: '800px', margin: '20px' }"
    styleClass="new-pocket-modal bg-primary-linear"
    [appendTo]="isSearch ? 'body' : null">
    <ng-template pTemplate="header">
      <p-header class="modal-title">Create Pocket</p-header>
    </ng-template>

  @if(detailsPocketModal)
  {
    <app-pocket-setup
        (saveChanges)="newPocketSubmit($event)"
        (cancel)="onFlag('detailsPocketModal', false)"
        [detailPocketMode]="'create'"
        [modalErrors]="modalErrors">
    </app-pocket-setup>
  }
</p-dialog>

@if (isMobile) {
  <p-dialog
    (onHide)="clearCarouselAllPocketsVariable()"
    [visible]="showSaveBusinessDialog"
    (visibleChange)="onFlag('showSaveBusinessDialog', $event)"
    [blockScroll]="false"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="false"
    [position]="'bottom'"
    [resizable]="false"
    [baseZIndex]="4000"
    maskStyleClass="save-business-mobile-dialog-mask"
    [style]="{
      margin: '0',
      width: '100vw',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px'
    }"
    class="dialog save-business-mobile-dialog"
    styleClass="save-business-mobile-panel"
    appendTo="body">
    <ng-template pTemplate="header">
      <div class="save-pocket-dialog-heading m-0">
               <h2 class="text-nowrap text-white p-5">Choose a Pocket</h2>
        <div class="absolute flex justify-content-between w-full left-0 p-5">
          <h2 class="text-nowrap">Choose a Pocket</h2>
          <button
            (click)="onFlag('detailsPocketModal', true)"
            class="create-pocket-button"
            type="button">
            <span aria-hidden="true" class="plus-icon">+</span>
            <span>Create new pocket</span>
          </button>
        </div>
      </div>
    </ng-template>
    <div class="mobile-pockets-container gap-6 px-5 pt-0">
      @if (carouselAllPocketsLoader) {
        <div class="pocket-dummy">
          <i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
        </div>
      }

      @for (mobilePocket of carouselAllPockets(); track $index) {
        @let pocketColor =
          mobilePocket?.organizationId
            ? '#24aeb5'
            : '#' +
              (mobilePocket?.hexColor && !mobilePocket.default
                ? mobilePocket.hexColor
                : mobilePocket.color);

        <app-pitchcard-folder-thumbnail
          [pocketColor]="pocketColor"
          (addContent)="saveBusinessToPocket($event, '')"
          [onlyFolder]="true"
          [pitchCardFolder]="mobilePocket"
          [scaleFactor]="mobilePocketScale"
          class="mobile-pocket">
        </app-pitchcard-folder-thumbnail>
      }
    </div>
  </p-dialog>
}
